import React, { PropTypes } from 'react'
import css from './style.scss'

const DEFAULT_INSTRUCTIONS = 'Activate using your institutional email address.'
const DEFAULT_BUTTON_TEXT = 'Activate'
const LOGIN_BUTTON_TEXT = 'Login'
const LOGIN_LINK = '/login'

const ActivateMembershipCard = ({ institutionName, institutionSlug, config, buttonBackground, textColor }) => {
  const instructions = (config && config.activation_instructions) || DEFAULT_INSTRUCTIONS
  const defaultLink = institutionSlug ? `/institutions/${institutionSlug}/register` : '/register'
  const activationLink = (config && config.activation_link) || defaultLink

  const buttonStyle = buttonBackground ? { backgroundColor: buttonBackground, borderColor: buttonBackground } : {}
  const titleStyle = textColor ? { color: textColor } : {}

  return (
    <div className={css.activationCard}>
      <h2 className={css.activationCardTitle} style={titleStyle}>Activate Your NCFDD Membership</h2>
      <p className={css.activationCardInstructions}>{instructions}</p>
      <a
        href={activationLink}
        className={css.activationButton}
        style={buttonStyle}
        target='_blank'
        rel='noopener noreferrer'
      >
        {DEFAULT_BUTTON_TEXT}
      </a>
      <a
        href={LOGIN_LINK}
        className={css.loginButton}
        style={buttonStyle}
      >
        {LOGIN_BUTTON_TEXT}
      </a>
    </div>
  )
}

ActivateMembershipCard.propTypes = {
  institutionName: PropTypes.string,
  institutionSlug: PropTypes.string,
  config: PropTypes.shape({
    activation_instructions: PropTypes.string,
    activation_link: PropTypes.string
  }),
  buttonBackground: PropTypes.string,
  textColor: PropTypes.string
}

export default ActivateMembershipCard
